import { useContext, useEffect, useState, JSX } from 'react';
import QuickTranslateQ1 from '@/components/elements/languages/QuickTranslateQ1'
import QuickTranslateQ2 from '@/components/elements/languages/QuickTranslateQ2'
import QuickTranslateQ3 from '@/components/elements/languages/QuickTranslateQ3'
import { LanguageContext } from '@/context/LanguageContext';
import ProgressBar from '@/components/elements/languages/ProgressBar'
import { INotificationBar, NotificationType } from '@/components/elements/languages/NotificationBar';
import { NotificationStatus } from '@/interfaces/languages';
import { container, TYPES } from '@/inversifyconfig/container.config';
import { IHttpRequest } from '@/interfaces/IHttp';

const QuickTranslate = ({close}:{close: (notif:INotificationBar) => void}) => {

    
    const httpCall = container.get<IHttpRequest>(TYPES.IHttpRequest);
    
    const [currentProgress, setCurrentProgress] = useState<number>(1)
    const [formValid, setFormValid] = useState<boolean>(false);

    const languageContext = useContext(LanguageContext);

    // Clear store on mount
    useEffect(() => {

        languageContext.setStore({
            languageAvailable:[...languageContext.store.languageAvailable],
            languageSelected:[],
            languageOption:0,
            translateScope:null
        })

    }, [])

    // Auto validate
    useEffect(() => {

        switch (currentProgress) {
            case 1:
                languageContext.store.languageSelected.length ? setFormValid(true) : setFormValid(false);
                break;
               
            case 2:
                languageContext.store.translateScope !== null ? setFormValid(true) : setFormValid(false);
                break;

            case 3:
                setFormValid(true) 
                break;
              
        }

    }, [languageContext.store, currentProgress]);


    function Page():JSX.Element {

        switch (currentProgress) {
            case 1:
                return <QuickTranslateQ1 />
            case 2:
                return <QuickTranslateQ2 />
            case 3:
                return <QuickTranslateQ3 />
        }

        return <QuickTranslateQ1 />
    }

    function next(){
        switch (currentProgress) {
            case 1:

                if (languageContext.store.languageSelected.length){
                    setCurrentProgress(currentProgress+1)
                }
                break

            case 2:

                if(languageContext.store.translateScope !== null){
                   setCurrentProgress(currentProgress+1)             
                }    
                break  

            case 3:
                // Save
                httpCall.post(
                    `admin/languages/batch?translationType=${languageContext.store.translateScope}`, 
                    formatPostBody()
                )
                .then(() => {
                    close({
                        show:true, 
                        notificationStatus:NotificationStatus.success, 
                        msg:`😁 Automatic Translations has started!`, 
                        notificationType:NotificationType.quickTranslate
                    })
                })
                .catch(() => {
                    close({
                        show:true, 
                        notificationStatus:NotificationStatus.error, 
                        msg:`😱 Automatic Translations has failed, please try again`, 
                        notificationType:NotificationType.quickTranslate
                    })
                });
                
                break
        }
    }

    function formatPostBody():any[] {
        const ids = languageContext.store.languageSelected.map(language => language.languageId);
        return languageContext.store.languageAvailable.map(language => ({
            LocalisationOrganisationId: language.localisationOrganisationId,
            enabled: ids.includes(language.languageId)
        }))
    }


    return (
        <div className='languageModal quickTranslate'>
            
            <h2>Quick Translate</h2>

            <ProgressBar currentProgress={currentProgress} setCurrentProgress={setCurrentProgress} />

            <div className='qt-content'>
                {Page()}
            </div>

            <div className='controls-container'> 

                {currentProgress > 1 ? 
                    <button className={`cancel`} onClick={() => setCurrentProgress(currentProgress-1)}>Previous Step</button> : <span>&nbsp;</span>
                }
   
                <button className={`next ${!formValid ? 'disabled' : ''}`} onClick={next}>{currentProgress < 3 ? 'Next Step' : 'Translate'}</button>
             
            </div>

        </div>
    );
};

export default QuickTranslate;